<template>
  <div>
    <header id="blog-header">
      <div class="inner ">
        <nav id="navigation">
          <span class="blog-logo">
          </span>
        </nav>
      </div>
    </header>

    <blogpostpanel v-if="blogpost" :blogpost="blogpost" :expanded="true">
    </blogpostpanel>
    <div v-if="blogpost" class="inner comments-inner">
      <article-comments
        :key="blogpost.pk"
        :post-id="blogpost.pk"
      />
    </div>

  </div>
</template>

<script>
import blogpostpanel from './BlogPost'
import ArticleComments from '../components/ArticleComments'
export default {
  name: 'post-detail',
  components: {
    blogpostpanel,
    ArticleComments
  },
  data() {
    return {
      blogpost: null
    }
  },
  computed: {},
  beforeCreate() {

  },
  created () {
    this.getBlogPost();
  },
  watch: {
    '$route.params.url': function () {
      this.getBlogPost()
    }
  },
  methods: {
    async getBlogPost () {
      let url = this.$route.params.url;
      let pk = this.getPk(url);
      let blogPostCache = this.$store.state.blogPost || {};
      let reqUrl = this.$store.state.baseUrl + url;
      console.log(reqUrl);
      this.blogpost = null;
      await this.$http.get(reqUrl)
          .then((response) => {
            var res = JSON.parse(response.bodyText);
            this.blogpost = res.blogpost;
            blogPostCache[pk] = res.blogpost;
            this.$store.commit('assignBlogPost', blogPostCache);
            console.log(this.blogpost)
          })
    },
    getPk(url){
      let eleList = url.split(',');
      let pkStr = eleList[eleList.length-1];
      return parseInt(pkStr.substring(0, pkStr.indexOf("/")))
    }
  }
}
</script>

<style scoped>
  .comments-inner {
    max-width: 1120px;
    width: 86%;
    margin-left: auto;
    margin-right: auto;
  }
</style>
